const routes = [
  {
    path: "/",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "/",
        component: () => import("pages/IndexLanding.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: "home",
          titleKey: "app.pages.index.toolbarTitle",
        },
      },
      {
        path: "app",
        component: () => import("pages/AppLandingPage.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: false,
          titleKey: "app.pages.index.toolbarTitle",
        },
      },
      {
        path: "app-privacy",
        component: () => import("pages/AppPrivacyPage.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: false,
          titleKey: "app.pages.index.toolbarTitle",
        },
      },
      {
        path: "voor-ouders",
        component: () => import("pages/ParentsLandingPage.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: "parents_landing",
          titleKey: "app.pages.parentsLanding.toolbarTitle",
        },
      },
      {
        path: "boek",
        component: () => import("pages/BookLandingPage.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: "book_landing",
          titleKey: "app.pages.booklanding.toolbarTitle",
        },
      },
      {
        path: "clarity",
        component: () => import("pages/ClarityLandingPage.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: "clarity_landing",
          titleKey: "app.pages.index.toolbarTitle",
        },
      },
      {
        path: "account",
        component: () => import("pages/AccountPage.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.account.toolbarTitle",
        },
      },
      {
        path: "feedback/:token",
        component: () => import("pages/ReportFeedbackPage.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.index.toolbarTitle",
        },
      },
      {
        path: "soulprofile",
        component: () => import("pages/ProfileSoul.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: "soulprofile",
          titleKey: "app.pages.soulprofile.toolbarTitle",
        },
      },
      {
        path: "relationprofile",
        component: () => import("pages/ProfileRelation.vue"),
        meta: {
          requiresAuth: true,
          titleKey: "app.pages.relationprofile.toolbarTitle",
        },
      },
      {
        path: "friendshipprofile",
        component: () => import("pages/ProfileFriendship.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.friendshipprofile.toolbarTitle",
        },
      },
      {
        path: "lovelanguage",
        component: () => import("src/pages/SendLovePage.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.lovelanguage.toolbarTitle",
        },
      },
      {
        path: "purposegenerator",
        component: () => import("pages/PurposeGenerator.vue"),
        meta: {
          requiresAuth: true,
          titleKey: "app.pages.purposegenerator.toolbarTitle",
        },
      },
      {
        path: "dagenergie",
        alias: "/dayenergy",
        component: () =>
          import("src/modules/dayEnergy/pages/DayEnergyPage.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: "dayenergy",
          titleKey: "app.pages.dayenergy.toolbarTitle",
        },
      },
      {
        path: "potatodarshan",
        component: () => import("pages/PotatoDarshan.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.potato.toolbarTitle",
        },
      },
      {
        path: "updatepassword",
        component: () => import("pages/UpdatePassword.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.updatepassword.toolbarTitle",
        },
      },
      {
        path: "democard",
        component: () => import("pages/DemoCard.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.democard.toolbarTitle",
        },
      },
      {
        path: "surveys",
        component: () => import("pages/Surveys.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.surveypage.toolbarTitle",
        },
      },
      {
        path: "admin-settings",
        component: () => import("pages/AdminSettings.vue"),
        meta: {
          requiresAuth: true,
          titleKey: "app.pages.adminsettings.toolbarTitle",
        },
      },
      {
        path: "book-interest",
        component: () => import("pages/BookInterest.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.bookinterest.toolbarTitle",
        },
      },
      {
        path: "shop",
        component: () =>
          import("src/modules/reportSales/pages/ReportShopPage.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: "shop",
          titleKey: "app.pages.shop.toolbarTitle",
        },
      },
      {
        path: "shop-test",
        component: () =>
          import("src/modules/reportSales/pages/ReportShopTestPage.vue"),
        meta: {
          requiresAuth: true,
          titleKey: "app.pages.shoptest.toolbarTitle",
        },
      },
      {
        path: "checkout/success",
        component: () =>
          import("src/modules/reportSales/pages/CheckoutSuccessPage.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: "checkout_success",
          titleKey: "app.pages.checkoutSuccess.toolbarTitle",
        },
      },
      {
        path: "checkout/cancelled",
        component: () =>
          import("src/modules/reportSales/pages/CheckoutCancelledPage.vue"),
        meta: {
          requiresAuth: false,
          sitePageViewKey: "checkout_cancelled",
          titleKey: "app.pages.checkoutCancelled.toolbarTitle",
        },
      },
      {
        path: "order-status/:token",
        component: () =>
          import("src/modules/reportSales/pages/OrderStatusPage.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.orderStatus.toolbarTitle",
        },
      },
      {
        path: "pdf-report",
        redirect: (to) => ({
          path: "/report-generator",
          query: to.query,
        }),
        meta: {
          requiresAuth: true,
          titleKey: "app.pages.pdfreport.toolbarTitle",
        },
      },
      {
        path: "pdf-report-template",
        redirect: (to) => ({
          path: "/report-generator",
          query: to.query,
        }),
        meta: {
          requiresAuth: true,
          titleKey: "app.pages.pdfreport.toolbarTitle", // Reusing title key for now or could add a new one
        },
      },
      {
        path: "report-generator",
        component: () =>
          import(
            "src/modules/reports/renderers/personalWheelFullA4/generator/PersonalWheelFullA4GeneratorPage.vue"
          ),
        meta: {
          requiresAuth: true,
          titleKey: "app.pages.pdfreport.toolbarTitle",
        },
      },
    ],
  },

  {
    path: "/app-preview",
    component: () =>
      process.env.WHEEL_NATIVE
        ? import("src/modules/wheelAppPreview/pages/WheelAppPreviewPage.vue")
        : import("src/modules/wheelAppPreview/pages/WheelAppAccessPage.vue"),
    meta: { requiresAuth: false, sitePageViewKey: false },
  },

  {
    path: "/app-energy-unsubscribe",
    component: () =>
      import(
        "src/modules/wheelAppPreview/pages/DailyEnergyEmailUnsubscribePage.vue"
      ),
    meta: { requiresAuth: false, sitePageViewKey: false },
  },

  {
    path: "/reading",
    alias: "/mini-reading",
    component: () =>
      import("src/modules/immersiveReading/pages/ImmersiveReadingPage.vue"),
    meta: {
      requiresAuth: false,
      sitePageViewKey: "immersive_reading",
      titleKey: "app.pages.index.toolbarTitle",
    },
  },

  {
    path: "/kompas",
    component: () =>
      import(
        "src/modules/soulProfilerCompass/pages/SoulProfilerCompassPage.vue"
      ),
    meta: {
      requiresAuth: true,
      sitePageViewKey: "soulprofiler_compass",
      titleKey: "app.pages.compass.toolbarTitle",
    },
  },

  {
    path: "/report-viewer",
    component: () =>
      import("src/modules/reportReader/layouts/ReportReaderLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("src/pages/SoulProfilerPdfReaderPage.vue"),
        meta: {
          requiresAuth: false,
          titleKey: "app.pages.soulprofile.toolbarTitle",
        },
      },
    ],
  },

  {
    path: "/report-reader-prototype",
    component: () =>
      import("src/modules/reportReader/layouts/ReportReaderLayout.vue"),
    children: [
      {
        path: "",
        component: () =>
          import(
            "src/modules/reportReaderV2/pages/OnlineReportReaderPrototypePage.vue"
          ),
        meta: {
          requiresAuth: true,
          prototype: true,
          titleKey: "app.pages.soulprofile.toolbarTitle",
        },
      },
    ],
  },

  {
    path: "/book-landing",
    redirect: "/boek",
  },
  {
    path: "/eva",
    alias: "/rise-by-eva",
    component: () => import("layouts/CustomerLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/CustomerPage.vue"),
        meta: {
          requiresAuth: true,
          titleKey: "app.pages.customerpage.toolbarTitle",
        },
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    component: () => import("pages/Error404.vue"),
  },
];

export default routes;
